<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option
      v-for="item in optionList"
      :label="item.partnerName"
      :value="item.partnerId"
      :key="item.partnerId"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'filter-partner',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    code: {
      type: null,
    },
    name: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      optionList: [],
      optionMap: {},
    }
  },

  created() {
    this.getOptionList()
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        const { partnerId = '', partnerCode = '', partnerName = '' } = this.optionMap[val] || {}
        this.$emit('update:value', partnerId)
        this.$emit('update:code', partnerCode)
        this.$emit('update:name', partnerName)
      },
    },
  },

  methods: {
    getOptionList() {
      if (this.optionList.length > 0) return
      this.fetch
        .get('commonGetPartners')
        .then((res) => {
          this.optionList = (res.data && res.data.partnerModelList) || []
          this.optionList.forEach((item) => {
            this.optionMap[item.partnerId] = item
          })
          if (this.required && this.optionList[0]) {
            this.selectedValue = this.optionList[0].partnerId
          }
        })
        .catch(() => {})
    },
  },
}
</script>
